webpackJsonp([13864273774487],{

/***/ 1731:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"CreditReason","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"id","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"isActive","type":{"kind":"SCALAR","name":"Boolean","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-credit-reason-0b52314fccd92a80bcc3.js